import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { installChunkLoadRecovery } from './chunk-load-recovery';
import { installWebVitalsBeacon } from './app/core/analytics/web-vitals.util';
import { environment } from './environments/environment';

installChunkLoadRecovery();
installWebVitalsBeacon();

platformBrowserDynamic()
  .bootstrapModule(AppModule, { ngZoneEventCoalescing: true })
  .then(() => {
    if (!environment.production || !('serviceWorker' in navigator)) {
      return;
    }
    const register = (): void => {
      navigator.serviceWorker.register('/sw.js').catch(() => undefined);
    };
    const ric = (window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void })
      .requestIdleCallback;
    if (typeof ric === 'function') {
      ric(register, { timeout: 4000 });
    } else {
      setTimeout(register, 3000);
    }
  })
  .catch(err => console.error(err));
